import React from "react";
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';


const OA_menus = [
    {
        label: 'Task Manager',
        type: "section",
        children: [
            {
                uri: "/task-manager/oa-workflow",
                label: 'OA Shell',
                type: "nav-item",
                icon: <ListAltOutlinedIcon sx={{ fontSize: 20 }} />
            },
            {
                uri: "/task-manager/post-grant-workflow",
                label: 'Post Grant',
                type: "nav-item",
                icon: <ListAltOutlinedIcon sx={{ fontSize: 20 }} />
            },
        ]
    },
];

export default OA_menus;
